export default __webpack_public_path__ + "static/media/Pot3.cee9e58f.svg";